"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChargerPortState = void 0;
var ChargerPortState;
(function (ChargerPortState) {
    ChargerPortState[ChargerPortState["Available"] = 1] = "Available";
    ChargerPortState[ChargerPortState["PluggedInWaitingForPayment"] = 2] = "PluggedInWaitingForPayment";
    ChargerPortState[ChargerPortState["Preparing"] = 3] = "Preparing";
    ChargerPortState[ChargerPortState["Charging"] = 4] = "Charging";
    ChargerPortState[ChargerPortState["Finished"] = 5] = "Finished";
    ChargerPortState[ChargerPortState["SettingUpNextSession"] = 6] = "SettingUpNextSession";
    ChargerPortState[ChargerPortState["Faulted"] = 7] = "Faulted";
    ChargerPortState[ChargerPortState["Unavailable"] = 8] = "Unavailable";
})(ChargerPortState = exports.ChargerPortState || (exports.ChargerPortState = {}));
